module.exports = __webpack_public_path__ + "media/images/athletes/92-82302a53e4d447b1bac37111a1c62f89.png";